import ConfirmModal from './container';

export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/components/ConfirmModal/index.js